export default "__VITE_ASSET__BZuYcO_O__"